import Text6 from './Text6'
export default Text6
